import abhijeetSingh from '../../assets/pastSpeaker/9.png'
import sandeepJain from '../../assets/pastSpeaker/1.png'
import shyamSunder from '../../assets/pastSpeaker/7.png'
import anubhavJain from '../../assets/pastSpeaker/10.png'
import arunGolaya from '../../assets/pastSpeaker/2.png'
import krishnanSunderrajan from '../../assets/pastSpeaker/3.png'
import saurabhJain from '../../assets/pastSpeaker/5.png'
import sunilShekhawat from '../../assets/pastSpeaker/6.png'
import abhishekDubey from '../../assets/pastSpeaker/8.png'
import ajayGarg from '../../assets/pastSpeaker/4.png'



export const speakerdata = [
  {
    name: "Mr. Sandeep Jain",
    position: "	Founder, Geeks for Geeks",
    image: sandeepJain,
  },
  {
    name: "Mr. Saurabh Jain",
    position: "	Founder Fun2Do Labs Ex VP Paytm",
    image: saurabhJain,
  },
  {
    name: "Mr. Commodore Arun Pratap Golaya",
    position: "Commodore Indian Navy",
    image: arunGolaya,
  },
  {
    name: "Mr. Krishnan Sunderrajan",
    position: "Founder, Loka",
    image: krishnanSunderrajan,
  },
  {
    name: "Mr. Dr Ajay K Garg Sir",
    position: "Director of MietY Govt of India",
    image: ajayGarg,
  },
  {
    name: "Mr. Dr Sunil K Shekhawat",
    position: "Cofounder and CEO of Sanchi Connect",
    image: sunilShekhawat,
  },
  
  {
    name: "Mr. Abhijeet Singh	",
    position: "President and CEO of TechSera",
    image: abhijeetSingh
  },
  {
    name: "Mr. Dr Shyam Sundar Pathak",
    position: "	Assiastant Commissioner-GST, Noida",
    image: shyamSunder,
  },
  {
    name: "Mr. Mr Anubhav Jain",
    position: "	Cofounder, HBMB, Jain Shikanji",
    image: anubhavJain,
  },
  {
    name: "Mr. Dr Abhishek Dubey",
    position: "	Founder, Muskaan Dreams",
    image: abhishekDubey,
  },
];
